/* tslint:disable:max-line-length */
import { type SegmentSpecificMessages } from "../../types/types";

export const identityMessages: SegmentSpecificMessages = {
  emailExplanation: "Personal email address is recommended",
  step: {
    personalInfo: {
      title: "Unlock Your Special Offer",
      subtitle: "Verify your current identity.",
      howDoesVerifyingWorkDetails:
        "To be eligible for this offer, you must have a valid driver license." +
        "<br></br>" +
        "{companyName} uses SheerID, a trusted partner, to verify your identity. SheerID only collects information that assists in verifying your eligibility. Additional information or documentation may be requested.",
      tryAgain: {
        title: "Check Your Name & other fields",
        subtitle: "Your information must match what is on your government-issued document(s).",
      },
      verifyingTitle: "Verifying your identity",
      submitButtonText: "Verify My Identity",
    },
    docUpload: {
      title: "To continue, upload documents that confirm your status",
      whoIsSheerId:
        "Document review is handled by SheerID, a trusted partner who specializes in verifying status.",
      uploadInstructions: "Upload a government-issued document that shows",
    },
    success: {
      title: "You've been verified",
      subtitle: "You are now eligible for this special offer.",
      redirectButtonText: "Continue",
    },
  },
};
